import { useMemo } from 'react';
import formatPhoneOffers from '../utils/formatPhoneOffers';

// memoized version of formatPhone util to enable memoized functions to use it's output as a dependency
export const useFormatPhone = ({ phone, province }) => {
  const memoizedPhone = useMemo(() => formatPhoneOffers(phone, province), [phone, province]);
  return memoizedPhone;
};
